export default function registerBundleViewer(Alpine) {
  Alpine.store("signing", { ackedRemaining: 0, allAcked: true });

  Alpine.data("bundleViewer", ({ requireAck, requiredItemIds, ackedItemIds }) => ({
    requireAck: !!requireAck,
    requiredIds: Array.isArray(requiredItemIds) ? requiredItemIds : [],
    acked: Array.isArray(ackedItemIds) ? [...ackedItemIds] : [],
    selectedItemId: null,

    init() {
      this.$nextTick(() => {
        const firstItem = this.$root.querySelector("[data-bundle-item-id]")?.dataset.bundleItemId;
        const firstUnacked = this.requiredIds.find((id) => !this.acked.includes(id));
        this.selectedItemId = firstUnacked || firstItem || this.requiredIds[0] || null;
        this.syncStore();
      });
      this.$watch("acked", () => this.syncStore());
      window.__bundleViewer = this;
    },

    syncStore() {
      const remaining = this.requireAck ? this.requiredIds.filter((id) => !this.acked.includes(id)).length : 0;
      Alpine.store("signing").ackedRemaining = remaining;
      Alpine.store("signing").allAcked = remaining === 0;
    },

    get ackedRequired() {
      return this.requiredIds.filter((id) => this.acked.includes(id)).length;
    },

    get ackedPct() {
      if (!this.requiredIds.length) return 100;
      return Math.round((this.ackedRequired / this.requiredIds.length) * 100);
    },

    selectItem(id) {
      this.selectedItemId = id;
    },

    async acknowledge(id, url) {
      try {
        const csrf = document.querySelector('meta[name="csrf-token"]')?.content;
        await fetch(url, {
          method: "POST",
          headers: { "X-CSRF-Token": csrf || "", Accept: "application/json" }
        });
        if (!this.acked.includes(id)) this.acked.push(id);
      } catch (e) {
        console.error("ack failed", e);
      }
    },

    allowSign() {
      if (!this.requireAck) return true;
      return this.requiredIds.every((id) => this.acked.includes(id));
    }
  }));
}
